// Module
var code = " <div class=\"fullscreen-overlay\" ng-click=\"$ctrl.showEditTools()\" ng-mousemove=\"$ctrl.revealOverlay()\" ng-class=\"{'showing': $ctrl.showingOverlay}\"> <p class=\"md-display-1\" layout=\"row\" layout-align=\"start center\"> <md-icon>visibility</md-icon> <span translate=\"EXIT_FULL_SCREEN\"></span> </p> </div> ";
// Exports
export default code;